'use client'

import type { ComponentProps } from 'react'
import { down } from 'styled-breakpoints'
import { useBreakpoint } from 'styled-breakpoints/react-styled'
import DynamicCarousel from '../../dynamicCarousel'

interface TileCarouselProps {
  children: React.ReactNode
  dynamicCarouselProps?: ComponentProps<typeof DynamicCarousel>
  className?: string
}

export const TileCarousel = ({
  children,
  className,
  dynamicCarouselProps = {},
}: TileCarouselProps) => {
  const isMobile = useBreakpoint(down('md'))

  return (
    <DynamicCarousel
      className={className}
      itemPadding={[0, 20, isMobile ? 0 : 20, 0]}
      breakPoints={[
        { width: 1, itemsToShow: 1, itemsToScroll: 1, pagination: false },
        { width: 760, itemsToShow: 2, itemsToScroll: 2 },
        { width: 1150, itemsToShow: 3, itemsToScroll: 3 },
      ]}
      {...dynamicCarouselProps}
    >
      {children}
    </DynamicCarousel>
  )
}
